import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AppPageHeader from "../components/AppPageHeader";

function Landing() {
  const navigate = useNavigate();
  const { isAuthenticated, user, logout } = useAuth();

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#fff",
        color: "#2f2f2d",
        fontFamily: "system-ui, -apple-system, Segoe UI, sans-serif",
      }}
    >
      {isAuthenticated() && user ? (
        <AppPageHeader
          title="dehisce"
          user={user}
          onLogout={() => {
            logout();
            navigate("/");
          }}
        />
      ) : (
        <AppPageHeader title="dehisce" metaLine="dehisce.com" />
      )}

      <main style={{ padding: "16px", maxWidth: "420px", boxSizing: "border-box" }}>
        {isAuthenticated() ? (
          <button
            type="button"
            className="auth-primary-button"
            onClick={() => navigate("/account")}
          >
            Go to Accounts
          </button>
        ) : (
          <button
            type="button"
            className="auth-primary-button"
            onClick={() => navigate("/login")}
          >
            Login
          </button>
        )}
      </main>
    </div>
  );
}

export default Landing;
